// Footgun-предупреждение про blacklist роль-критичных инструментов.
//
// Спека 03-agents/roles/overrides § «Footgun»: blacklist может запретить инструмент,
// без которого роль не работает (например, `Bash` у reviewer'а — нужен для
// прогона тестов/линтеров). Системной защиты нет: единственный барьер —
// подтверждение человеком в UI, поэтому форма ДОЛЖНА предупреждать о
// роль-критичных инструментах. Это не блокировка (запрет всё равно можно
// поставить), а явное предупреждение.
//
// Список роль-критичных инструментов держим здесь чистой таблицей, чтобы
// юнитить решение напрямую (Mantine Select onChange в jsdom не зовётся) и
// переиспользовать в управляющей секции и в форме apply на /self-improvement.

// Инструменты, без которых роль фактически не способна выполнить работу.
// Сравнение по точному имени инструмента; роль — нормализуем регистром.
const ROLE_CRITICAL_TOOLS: Readonly<Record<string, readonly string[]>> = {
  // reviewer прогоняет тесты/линтеры через Bash — без него ревью неполноценно.
  reviewer: ["Bash"],
  // coder пишет код и коммитит — Write/Edit/Bash для него критичны.
  coder: ["Bash", "Write", "Edit"],
};

/**
 * Чистая проверка «запрет этого инструмента для этой роли — footgun?».
 * Возвращает `true`, если инструмент входит в роль-критичный набор роли.
 * Регистр роли нормализуем (Select отдаёт каноничное имя, но страхуемся);
 * имя инструмента сравниваем как есть (claude чувствителен к регистру).
 */
export function isRoleCriticalTool(
  roleName: string,
  toolName: string,
): boolean {
  const critical = ROLE_CRITICAL_TOOLS[roleName.trim().toLowerCase()] ?? [];
  return critical.includes(toolName.trim());
}
